export enum RolesEnum {
  'admin' = 'admin',
  'USER' = 'USER',
  'USER_UP' = 'USER_UP',
  'USER_UP_PREMIUM' = 'USER_UP_PREMIUM',
  'SCOPE_profile' = 'SCOPE_profile',
  'SCOPE_openid' = 'SCOPE_openid',
  'SCOPE_email' = 'SCOPE_email',
}
